<template>

  <v-container fluid >
      <v-layout row wrap>
        <v-flex xs12 md12>


                <v-card>


                <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                        <v-text-field  v-model="companyData.name" label="Company Name" ref="companyName" required :rules="companyNameRules"></v-text-field>
                    </v-flex>
                  
                    <v-flex xs11 sm11>
                        <v-autocomplete v-model="companyData.tz.name" prepend-icon=" " :items="timeZones" label="Select Timezone" required chips></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 sm1 style="text-align: -webkit-center;">
                        <v-btn fab slot="activator" class="gps-btn"  @click.native="autoDetectTimeZone"><v-icon>my_location</v-icon></v-btn>
                     
                    </v-flex>
                    <v-flex xs12 sm font-size: 12px;12 md12>
                      <v-alert
                        v-model="updateAlert"
                        dismissible
                        :color="updateAlertColor"
                        transition="scale-transition"
                        :icon="updateAlertIcon"
                      >
                        {{updateAlertMsg}}
                      </v-alert>
                    </v-flex>

                    </v-layout>
                </v-container>
                </v-card-text>


                <v-spacer></v-spacer>

               <div class="text-xs-center"><v-btn color="green" class="company-save-btn" large @click.native="saveCompany">Save</v-btn></div>


            </v-card>


        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapState } from 'vuex';


import canSee from '@/utilities/canSee';

export default {
  data() {
    return {
      companyNameRules: [
        v => /^[A-Za-z0-9-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || 'Please enter a valid company name.',
      ],
      countries: [],
      timeZones: [],
      updateAlert: false,
      updateAlertMsg: '',
      updateAlertColor: '',
      updateAlertIcon: '',
      companyData: {
        name: '',
        address: '',
        tz: '',
      }

    };
  },
  created() {
    // this.getCountriesList()

    this.getCompanyData();

    this.timeZones = moment.tz.names();
    const zoneList = this.timeZones;
    this.companyData.tz = zoneList[0];
  },
  methods: {
    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },
    /* getCountriesList: function() {
            this.$http.get('https://restcountries.eu/rest/v1/all').then(function(response) {

               
                this.countries = response.body

            })
      }, */

    autoDetectTimeZone() {
      this.companyData.tz.name = moment.tz.guess();
    },

    getCompanyData() {
      this.$http.get(`${this.$store.state.endpoint}companies/${this.$store.state.userDetails.companyId}`).then((response) => {
       
        this.companyData = response.body;
        // this.signupCountry = response.body.country

        
      }, (error) => {
        console.log(error);
        // error callback
      });
    },


    saveCompany() {
      if (this.$refs.companyName.validate() == false) {
       
        this.$swal({
          type: 'error',
          text: 'Please enter a valid company name to continue',
        });
      } else {
       

        const itemObj = this.companyData;

        const selectedTimezone = itemObj.tz.name;
        const toOffset = moment().tz(selectedTimezone).utcOffset();
        itemObj.tz = {
          name: selectedTimezone,
          offset: toOffset.toString(),
        };

        const updateObj = {

          // address: itemObj.address,
          // country: itemObj.country,
          name: itemObj.name,
          tz: itemObj.tz,

        };
       

        this.$http.patch(`${this.$store.state.endpoint}companies/${this.$store.state.userDetails.companyId}`, updateObj).then((response) => {
          // success callback
        
          this.updateAlert = true;
          this.updateAlertMsg = 'Organization Settings Updated Successfully';
          this.updateAlertColor = 'success';
          this.updateAlertIcon = 'check_circle';
        }, (error) => {
          console.log(error);
          this.updateAlert = true;
          this.updateAlertMsg = 'Organization Settings Update Failed Please Try Again ';
          this.updateAlertColor = 'error';
          this.updateAlertIcon = 'warning';
        });
      }
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
.gps-btn{
  /* margin-left: 327px;
  z-index: 1;
  top: -35px; */
  margin-left: -190px;
  background: transparent !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 600px) {
  .gps-btn {
    margin-left: -120px;
  }
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.company-save-btn{
color: #ffffff;
letter-spacing: 1px;
margin-bottom: 20px;
font-size: 16px;
}

</style>
